import $i18n, { withI18n } from 'panda-i18n';
import locale from '@/locale';
import React from 'react';
import { observer, RecursionField, useField, useFieldSchema, } from '@formily/react';
import { CnIcon } from '@/components/cn-icon';
import { CnCard } from '@/form/cn-card';
import cls from 'classnames';
import { ArrayBase } from '../array-base';
import './index.scss';
export const CnFormArrayCard = observer((props) => {
    const { autoIncrementTitle, additionText, hasDeleteButton, defaultValue } = props;
    const field = useField();
    const schema = useFieldSchema();
    const dataSource = Array.isArray(field.value) ? field.value : [];
    const defaultCardTitle = $i18n.get({
        id: 'Cards',
        dm: '卡片',
        ns: 'CnFormArrayCard',
    });
    return (React.createElement(ArrayBase, null,
        React.createElement("div", { "data-name": "CnFormArrayCard", ...props, className: cls('cn-ui-m-form-array-card-container', props.className) },
            dataSource?.map((item, index) => {
                const items = Array.isArray(schema.items)
                    ? schema.items[index] || schema.items[0]
                    : schema.items;
                return (React.createElement(ArrayBase.Item, { key: index, index: index, record: () => field.value?.[index] },
                    React.createElement(CnCard, { subTitle: `${autoIncrementTitle || defaultCardTitle} ${index + 1}`, subAction: hasDeleteButton &&
                            field.editable && (React.createElement(CnIcon, { type: "icon-minus-r", onClick: () => field.remove(index) })) },
                        React.createElement(RecursionField, { schema: items, name: index }))));
            }),
            React.createElement(ArrayBase.Addition, { title: additionText ||
                    $i18n.get({ id: 'New', dm: '新增', ns: 'CnFormArrayCard' }), defaultValue: defaultValue }))));
});
CnFormArrayCard.displayName = 'CnFormArrayCard';
CnFormArrayCard.defaultProps = {
    hasDeleteButton: true,
};
const i18nCnFormArrayCard = withI18n(CnFormArrayCard, {
    locale,
    _noHoc: true,
});
ArrayBase.mixin(i18nCnFormArrayCard);
